import once from './once';
import { UUID } from './UUID';
export const getConnectionId = once(UUID);